<template>
  <div class="upload-choose">
    <!-- 选择上传方式 -->
    <iModal
      :class-name="'imguploadmodal'"
      width="800"
      @on-visible-change="chooseClose"
      :value="showed"
      :z-index="1100"
    >
      <p slot="header">图片素材</p>
      <div class="img-upload">
        <div class="iu-top f-tar">
          <Button @click="sendUploadLocal();chooseClose();" type="primary" ghost>上传</Button>
        </div>
        <div class="iu-box">
          <div class="iu-box-side">
            <div
              class="iu-box-side-item"
              :class="{active: albumActive === -1}"
              @click="looseChange"
            >未分组</div>
            <template v-if="albumData">
              <div
                v-for="(item, i) in albumData.items"
                :key="'side-item' + i"
                class="iu-box-side-item"
                :class="{active: albumActive === i}"
                @click="albumChange(item, i)"
              >{{item.name}}</div>
            </template>
            <div class="iu-box-side-item">
              <Poptip 
                width="300"
                class="add-group-box"
                v-model="addVisible"
                @on-cancel="groupName=''"
              >
                <span>新建分组</span>
                <div slot="content" class="add-group">
                  <div class="title">新建分组</div>
                  <div class="content">
                    <Input
                      v-model="groupName" 
                      :maxlength="5"
                      placeholder="请输入分组名称"
                      style="width: 100%"
                    />
                  </div>
                  <div class="bottom">
                    <Button type="primary" :loading="addLoading" @click="handleAddAlbum">确定</Button>
                    <Button @click="addVisible=false">取消</Button>
                  </div>
                </div>
              </Poptip>
            </div>
            <!-- <div v-else class="my-empty">暂无分组<br><Button type="text" ghost style="color: #2d8cf0;" @click="$router.push('/exhibition/index/material/photo/all')">添加</Button></div> -->
          </div>
          <div class="iu-box-wrapper">
            <template v-if="hasList">
              <div
                class="iu-box-wrapper-item"
                v-for="(item, i) in list.items"
                :key="'iu-box-wrapper-item' + i"
                :class="{active: arrIndex(item) !== -1}"
                @click="addSelect(item)"
              >
                <img :src="item.path" :alt="item.name" />
                <!-- <div class="info">500*500</div> -->
                <div class="select f-tar">
                  <Badge :count="arrIndex(item) + 1" class="my-badge" v-if="arrIndex(item) !== -1"></Badge>
                </div>
              </div>
            </template>
            <div v-else class="u-empty">暂无数据</div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Row type="flex" justify="end">
          <Col span="16" class="f-tal">
            <Page
              show-total
              show-elevator
              :page-size="pageSize"
              :current="pageIndex"
              :total="totalCount"
              @on-change="pageSizeChange"
              v-if="hasPage"
            />
          </Col>
          <Col span="8">
            <Button type="primary" @click="materialClose()">确认</Button>
            <Button @click="chooseClose()">取消</Button>
          </Col>
        </Row>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "imgUpload",
  model: {
    prop: "showed",
    event: "change"
  },
  props: {
    showed: Boolean,
    fileType: String,
    maxCount: Number
  },
  data() {
    return {
      addLoading: false, // 添加 add
      addVisible: false,
      groupName: "", // 分组名称
      selectArr: [],
      albumId: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,

      albumActive: -1,
      albumData: null,

      dialogShowed: false,
      list: [],
      selectList: [],
      selectAlbumId: null
    };
  },
  watch: {
    showed(val, oldVal) {
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      material: "materialModule/getMaterial",
      videoMaterial: "materialModule/getVideoMaterial"
    }),
    showHome() {
      let bool = true;
      if (this.$route.path.indexOf("/host/index") !== -1) {
        bool = false;
      }
      if (this.$route.path.indexOf("/host/project") !== -1) {
        bool = false;
      }
      return bool;
    },
    query() {
      return {
        CompId: this.company.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    },
    option() {
      return {
        CompId: this.company.id,
        pageSize: 1000
      };
    },
    initOption() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    },
    initOption2() {
      return {
        By: this.albumId,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    },
    hasList() {
      return this.list && this.list.items && this.list.items.length;
    },
    hasPage() {
      return (
        this.list && this.list.items && this.totalCount > this.list.items.length
      );
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getAlbumPhotoByAlbumId: "albumModule/getAlbumPhotoByAlbumId",
      getAlbum: "albumModule/getAlbum",
      getAlbumByOut: "albumModule/getAlbumByOut",
      addAlbum: "albumModule/addAlbum"
    }),
    addSelect(item) {
      let len = this.arrIndex(item);
      if (len !== -1) {
        this.selectArr.splice(len, 1);
      } else {
        if (this.maxCount === 1 && this.selectArr.length === 1) {
          this.selectArr = [];
          this.selectArr.push(item.path);
          return;
        }
        if (this.selectArr.length >= this.maxCount) {
          this.$Message.warning(
            `文件数量是超过限制,当前可上传文件最大数量为:${this.maxCount}`
          );
          return;
        } else {
          this.selectArr.push(item.path);
        }
      }
    },
    async init() {
      // if (this.showHome) {
      //   this.albumData = await this.getAlbum(this.option);
      //   this.getListData();
      // }
    },
    looseChange() {
      this.albumActive = -1;
      this.albumId = null;
      this.pageSize = 20;
      this.pageIndex = 1;
      this.totalCount = 0;
      this.getListData();
    },
    getListData() {
      if (this.albumActive === -1) {
        this.getAllData();
      } else {
        this.getGroupData();
      }
    },
    arrIndex(item) {
      let len = this.selectArr.indexOf(item.path);
      return len;
    },
    async getGroupData() {
      let listData = await this.getAlbumPhotoByAlbumId(this.initOption2);
      if (listData) {
        listData.items.sort((a, b) => {
          let lastTime = new Date(a.inTime).getTime();
          let endTime = new Date(b.inTime).getTime();
          return lastTime > endTime;
        });
        this.list = listData;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    async getAllData() {
      let listData = await this.getAlbumByOut(this.initOption);
      if (listData) {
        listData.items.sort((a, b) => {
          let lastTime = new Date(a.inTime).getTime();
          let endTime = new Date(b.inTime).getTime();
          return lastTime > endTime;
        });
        this.list = listData;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    async handleAddAlbum() {
      if (!this.groupName) return;
      this.addLoading = true;
      setTimeout(() => {
        this.addLoading = false;
      }, 5000);
      // 添加图集
      const req = {
        CompId: this.company.id,
        Name: this.groupName,
        Cover: "",
        ItemName: this.groupName,
        StyleId: "1",
        Introduction: this.groupName,
        Tag: this.groupName
      }; 
      this.addAlbum(req)
        .then(v => {
          this.init();
          this.$Message.success("添加成功");
          this.groupName = "";
          this.addLoading = false;
          this.addVisible = false;
        })
        .catch(e => {
          this.$Message.error("添加失败，请重新尝试");
          this.loading = false;
        });
    },
    albumChange(item, i) {
      this.selectAlbumId = item.id;
      this.albumActive = i;
      if (this.albumId !== item.id) {
        this.selectArr = [];
        this.albumId = item.id;
        this.pageSize = 20;
        this.pageIndex = 1;
        this.totalCount = 0;
        this.getListData();
      }
    },
    chooseClose(e) {
      this.$emit("change", e);
      this.list = [];
      this.selectArr = [];
      this.albumId = null;
      this.pageSize = 20;
      this.pageIndex = 1;
      this.totalCount = 0;
      this.selectAlbumId = null;
      this.albumActive = -1;
    },
    materialClose() {
      this.dialogShowed = false;
      this.$emit("upload:material", this.selectArr);
    },
    pageSizeChange(e) {
      this.pageIndex = e;
      this.getListData();
    },
    sendUploadLocal() {
      if(this.showHome) {
        if (this.selectAlbumId && this.albumActive !== -1) {
          const req = {
            CompId: this.company.id,
            AgentId: this.company.agentId,
            Name: "",
            Path: "",
            ShowIndex: 0,
            albumId: this.selectAlbumId
          };
          this.$emit("upload:local", req);
        } else {
          const req = {
            CompId: this.company.id,
            AgentId: this.company.agentId,
            Name: "",
            Path: "",
            ShowIndex: 0
          };
          this.$emit("upload:local", req);
        }
      } else {
        this.$emit("upload:local");
      }
    }
  }
};
</script>

<style lang="scss">
.my-badge {
  .ivu-badge-count {
    box-shadow: none;
    background: #1890ff;
  }
}
.imguploadmodal {
  .ivu-modal-body {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.img-upload {
  .iu-box-side-item.active {
    color: #1890ff;
  }
  .iu {
    &-top {
      padding: 10px 20px;
    }
    &-box {
      height: 560px;
      display: flex;
      &-side {
        overflow: auto;
        width: 120px;
        height: 560px;
        background-color: #f2f2f2;
        &-item {
          line-height: 44px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 5px;
          text-align: center;
          border-bottom: solid 1px #ddd;
          cursor: pointer;
          &.active,
          &:hover {
            color: #1890ff;
          }
        }
      }
      &-wrapper {
        flex: 1;
        padding-left: 10px;
        &-item {
          display: inline-block;
          width: 120px;
          height: 120px;
          border-radius: 2px;
          position: relative;
          cursor: pointer;
          margin-bottom: 10px;
          margin-left: 10px;
          &:hover,
          &.active {
            .select {
              visibility: visible;
            }
          }
          img {
            max-width: 120px;
            max-height: 120px;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
          .info {
            position: absolute;
            width: 100%;
            color: #fff;
            text-align: center;
            font-size: 12px;
            bottom: 0;
            left: 0;
            line-height: 30px;
            background-color: rgba(#333, 0.8);
            z-index: 1;
          }
          .select {
            width: 120px;
            height: 120px;
            bottom: 0;
            left: 0;
            z-index: 2;
            padding: 10px;
            background-color: rgba(#000, 0.4);
            visibility: hidden;
            position: absolute;
          }
        }
      }
    }
  }
}
.my-badge {
  .ivu-badge-count {
    border-color: #ed4014;
  }
}
.my-page {
  height: 50px;
  padding: 10px;
}
.my-empty {
  text-align: center;
  padding-top: 50px;
  font-size: 12px;
}
.add-group-box {
  .ivu-poptip-body {
    padding: 0;
    margin: 0;
    width: 300px;
    height: 218px;
  }
  .add-group {
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
    text-align: left;
  }
  .title {
    padding: 20px 30px;
    font-size: 18px;
    color: #333;
    border-bottom: 1px solid #ddd;
  }
  .content {
    padding: 30px 16px;
  }
  .bottom {
    border-top: 1px solid #ddd;
    text-align: right;
    padding: 12px 30px;
    button {
      margin-left: 10px;
    }
  }
}
</style>